export const BASE_ROUTE = '/';
export const LOGIN_ROUTE = 'login';
export const COUNTER_ROUTE = 'counter';
export const MOVIES_ROUTE = 'movies';
export const NAVIGATION_LINKS = [MOVIES_ROUTE, COUNTER_ROUTE, LOGIN_ROUTE];
